<template>
  <a
    href="https://www.soldera.org/corporate/registry-bridge"
    target="_blank"
    rel="noopener noreferrer"
    class="topnav-powered-by d-none d-sm-flex align-items-center"
    :title="$t('branding.powered_by_soldera')"
  >
    <span class="topnav-powered-by__divider" />
    <span class="topnav-powered-by__prefix me-2">
      {{ $t("branding.powered_by") }}
    </span>
    <img
      :src="solderaCircularLogo"
      alt="Soldera"
      class="topnav-powered-by__icon me-2"
    />
    <span class="text-start">
      <span class="topnav-powered-by__name d-block">Soldera</span>
      <span class="topnav-powered-by__sub d-block">
        {{ $t("branding.registry_infrastructure") }}
      </span>
    </span>
  </a>
</template>

<script setup lang="ts">
import solderaCircularLogo from "@/assets/img/logo/soldera-circular.png";

// Top-nav Soldera attribution lockup, rendered next to the provider's logo;
// links out to Soldera's registry-bridge page in a new tab.
</script>

<style scoped lang="scss">
.topnav-powered-by {
  border: 0;
  background: transparent;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.topnav-powered-by__divider {
  width: 1px;
  height: 2rem;
  background-color: #e5ded6;
  margin-right: 0.75rem;
}

.topnav-powered-by__prefix {
  font-size: 0.7rem;
  color: #9b968f;
}

.topnav-powered-by__icon {
  height: 1.75rem;
  width: 1.75rem;
  border-radius: 50%;
}

.topnav-powered-by__name {
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.1;
  color: #404041;
}

.topnav-powered-by__sub {
  font-size: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.2;
  color: #9b968f;
}
</style>
